import { Backdrop } from "@mui/material";
import React from "react";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  toggle: (value?: boolean) => void;
  divStyle?: any;
  children?: React.ReactNode;
  [otherProps: string]: any;
}

const AppDrawer: React.FC<Props> = ({
  isOpen,
  toggle,
  divStyle,
  children,
  ...otherProps
}) => {
  return (
    <StyleBackdrop open={isOpen} >
      <StyleDrawerWrapper open={isOpen} {...otherProps}>
        <div className="content" style={divStyle}>
          {children}
        </div>
      </StyleDrawerWrapper>
    </StyleBackdrop>
  );
};

export default AppDrawer;

interface StyleProps {
  open?: boolean;
}
const StyleDrawerWrapper = styled.div<StyleProps>`
  && {
    position: fixed;
    width: 100%;
    border-radius: 4px;
    /* height: ${(props: any) => (props?.open ? "auto" : 0)}; */
    /* top: ${(props: any) => (props?.open ? "4rem" : "-100vh")}; */
    bottom: ${(props: any) => (props?.open ? "0rem" : "-100%")};
    z-index: ${(props: any) => (props?.open ? 9 : -9)};
    transition: bottom 0.3s ease-in-out, z-index 0.3s ease-in-out;
    overflow: hidden;
    border-radius: 8px;
    .content {
      height: 100vh;
      width: 100vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;
const StyleBackdrop = styled(Backdrop)`
  && {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
  }
`;
